import type { ReactNode } from "react";
import { FaFileInvoiceDollar, FaUpload, FaWallet } from "react-icons/fa";
import stepsImage from "../assets/emisaathi-steps.png";
import "./container.css";
import "./StepsSection.css";

const SnapshotIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M12.4999 1.66675H4.99992C4.55789 1.66675 4.13397 1.84234 3.82141 2.1549C3.50885 2.46746 3.33325 2.89139 3.33325 3.33341V16.6667C3.33325 17.1088 3.50885 17.5327 3.82141 17.8453C4.13397 18.1578 4.55789 18.3334 4.99992 18.3334H14.9999C15.4419 18.3334 15.8659 18.1578 16.1784 17.8453C16.491 17.5327 16.6666 17.1088 16.6666 16.6667V5.83341L12.4999 1.66675Z" stroke="#283AAA" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.6667 1.66675V5.00008C11.6667 5.44211 11.8423 5.86603 12.1549 6.17859C12.4675 6.49115 12.8914 6.66675 13.3334 6.66675H16.6667" stroke="#283AAA" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.33341 7.5H6.66675" stroke="#283AAA" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.3334 10.8333H6.66675" stroke="#283AAA" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.3334 14.1667H6.66675" stroke="#283AAA" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const EligibilityIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M13.3334 17.5V15.8333C13.3334 14.9493 12.9822 14.1014 12.3571 13.4763C11.732 12.8512 10.8841 12.5 10.0001 12.5H5.00008C4.11603 12.5 3.26818 12.8512 2.64306 13.4763C2.01794 14.1014 1.66675 14.9493 1.66675 15.8333V17.5" stroke="#283AAA" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.50008 9.16667C9.34103 9.16667 10.8334 7.67428 10.8334 5.83333C10.8334 3.99238 9.34103 2.5 7.50008 2.5C5.65913 2.5 4.16675 3.99238 4.16675 5.83333C4.16675 7.67428 5.65913 9.16667 7.50008 9.16667Z" stroke="#283AAA" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.3333 9.16667L14.9999 10.8333L18.3333 7.5" stroke="#283AAA" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const TOP_STEPS = [
  { number: "01", icon: <SnapshotIcon />, lines: ["Understand Your", "Financial Snapshot"] },
  { number: "02", icon: <EligibilityIcon />, lines: ["Check Your Eligibility", "Instantly"] },
  { number: "03", icon: <FaFileInvoiceDollar />, lines: ["Preview Your New EMI", "Plan"] },
];

const BOTTOM_STEPS = [
  { number: "04", icon: <FaUpload />, lines: ["Upload Documents", "Securely"] },
  { number: "05", icon: <FaWallet />, lines: ["Get Approved & Simplify", "Payments"] },
];

const StepCard = ({
  step,
}: {
  step: { number: string; icon: ReactNode; lines: string[] };
}) => (
  <div className="step-card">
    <div className="step-card-badge">{step.number}</div>
    <div className="step-card-icon">{step.icon}</div>
    <p
      className="step-card-title"
      style={{ color: "#1A1A1A", fontStyle: "normal", fontWeight: 400, fontFamily: "Inter" }}
    >
      {step.lines.map((line, index) => (
        <span key={line} style={{ whiteSpace: "nowrap" }}>
          {line}
          {index < step.lines.length - 1 && <br />}
        </span>
      ))}
    </p>
  </div>
);

const StepsSection = () => {
  return (
    <section className="steps-section w-full">
      <div className="container-8xl">
        <div className="steps-top">
          <h2
            className="steps-heading"
            style={{ fontStyle: "normal", fontWeight: 500, fontFamily: "Inter" }}
          >
            <span style={{ color: "#000" }}>Get Your</span>
            <br />
            <span style={{ color: "#000" }}>Debt Consolidation</span>
            <br />
            <span style={{ color: "#000" }}>Plan </span>
            <span style={{ color: "#032799" }}>In 5 Easy Steps</span>
          </h2>

          <img
            src={stepsImage}
            alt="EMI Saathi debt consolidation steps illustration"
            className="steps-visual-image"
          />
        </div>

        <div className="steps-cards-top">
          {TOP_STEPS.map((step) => (
            <StepCard key={step.number} step={step} />
          ))}
        </div>

        <div className="steps-cards-bottom">
          {BOTTOM_STEPS.map((step) => (
            <StepCard key={step.number} step={step} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StepsSection;
